import { ChangeRequest } from 'app/shared/models';
import { ScenarioBase } from './base/scenario-base';
import { ScenarioDrillGroupFilterCriteria } from './scenario-drill-group-filter-criteria';
import { ScenarioObject } from './scenario-object';
import * as Library from '../library/index';

export class Scenario extends ScenarioBase {
  public ScenarioObjects: ScenarioObject;
  public ChangeRequests: ChangeRequest[];

  get PrelimFilterCriteria(): ScenarioDrillGroupFilterCriteria {
    return this.ScenarioObjects.PreliminaryFilterCriteria;
  }

  set PrelimFilterCriteria(value: ScenarioDrillGroupFilterCriteria) {
    this.ScenarioObjects.PreliminaryFilterCriteria = value;
  }

  public static create(scenarioId?: number, scenarioNumber?: number, scenarioStatusId?: number, scenarioTypeId?: number, name?: string): Scenario {
    let scenario = new Scenario();

    scenario.setDefaults();

    if (scenarioId !== undefined) {
      scenario.ScenarioId = scenarioId;
      scenario.ScenarioNumber = scenarioNumber;
      scenario.ScenarioStatusId = scenarioStatusId;
      scenario.ScenarioTypeId = scenarioTypeId;
      scenario.Name = name;
    }

    scenario.PrelimFilterCriteria = new ScenarioDrillGroupFilterCriteria();

    return scenario;
  }

  public static map(many: Scenario[]): Scenario[] {

    return many;
  }

  public setDefaults(): void {
    this.ScenarioId = 0;
    this.ScenarioNumber = 0;
    this.ScenarioStatusId = 0;
    this.ScenarioTypeId = 0;
    this.ScenarioObjects = new ScenarioObject();
    this.PrelimFilterCriteria = new ScenarioDrillGroupFilterCriteria();
    this.AssetTeamId = 1;
    this.CreateTStamp = new Date();
    this.Description = ' ';
    this.HasJointVentureRigs = false;
    this.HasPreSpudProgressConstraint = false;
    this.IsAllowableDayPopSlideConstraintApplied = false;
    this.IsAreaTeamRigConstraintApplied = false;
    this.IsCalenderRestrictionConstraintApplied = false;
    this.IsChokeConstraintApplied = false;
    this.IsConstrainedScheduleConstraintApplied = false;
    this.IsDrillFracInterferenceConstraintApplied = false;
    this.IsFacilityExpansionConstraintApplied = false;
    this.IsFacilityInitialBuildConstraintApplied = false;
    this.IsLeaseObligationConstraintApplied = false;
    this.IsManualObligationConstraintApplied = false;
    this.IsMaxFracFleetPerAreaConstraintApplied = false;
    this.IsMaxMinRigsConstraintApplied = false;
    this.IsMaxWaterExpressConstraintApplied = false;
    this.IsMaxWaterSupplyConstraintApplied = false;
    this.IsNoProductionForecast = false;
    this.IsPrematureWellShutinConstraintApplied = false;
    this.IsProvenUndrilledObligationConstraintApplied = false;
    this.IsSpudLimitConstraintApplied = false;
    this.IsTruckingConstraintApplied = false;
    this.Name = 'default';
    this.PublishId = 0;
    this.RigRampWellSet = false;
  }

  public static toDate(input: Date | string): Date | null {
    if (input instanceof Date) {
      return input as Date;
    }
    if (input === null) {
      return input as null;
    }
    if (typeof input === 'string') {
      //let m = Date.parse(input);
      return new Date(input as string);
    }
  }

  /**
   * hasScenario()
   * @returns {boolean}
   */
  public hasScenario() {
    return (Library.isDefined(this.ScenarioId));
  }

  public validate(): boolean {
    let m = this;

    let hasValue = (item: any): boolean => {
      return item !== null && item !== undefined;
    };

    let stringGood = (item: string): boolean => {
      return hasValue(item) && item.length > 0;
    };

    return hasValue(m.AssetTeamId) &&
      hasValue(m.CreateTStamp) &&
      stringGood(m.Description) &&
      hasValue(m.HasJointVentureRigs) &&
      hasValue(m.HasPreSpudProgressConstraint) &&
      hasValue(m.IsAllowableDayPopSlideConstraintApplied) &&
      hasValue(m.IsAreaTeamRigConstraintApplied) &&
      hasValue(m.IsCalenderRestrictionConstraintApplied) &&
      hasValue(m.IsChokeConstraintApplied) &&
      hasValue(m.IsConstrainedScheduleConstraintApplied) &&
      hasValue(m.IsDrillFracInterferenceConstraintApplied) &&
      hasValue(m.IsFacilityExpansionConstraintApplied) &&
      hasValue(m.IsFacilityInitialBuildConstraintApplied) &&
      hasValue(m.IsLeaseObligationConstraintApplied) &&
      hasValue(m.IsManualObligationConstraintApplied) &&
      hasValue(m.IsMaxFracFleetPerAreaConstraintApplied) &&
      hasValue(m.IsMaxMinRigsConstraintApplied) &&
      hasValue(m.IsMaxWaterExpressConstraintApplied) &&
      hasValue(m.IsMaxWaterSupplyConstraintApplied) &&
      hasValue(m.IsNoProductionForecast) &&
      hasValue(m.IsPrematureWellShutinConstraintApplied) &&
      hasValue(m.IsProvenUndrilledObligationConstraintApplied) &&
      hasValue(m.IsSpudLimitConstraintApplied) &&
      hasValue(m.IsTruckingConstraintApplied) &&
      stringGood(m.Name) &&
      hasValue(m.PublishId) &&
      hasValue(m.RigRampWellSet) &&
      hasValue(m.ScenarioId) &&
      hasValue(m.ScenarioNumber) &&
      hasValue(m.ScenarioStatusId) &&
      hasValue(m.ScenarioTypeId);
  }
}